<app-navigation
  [currentPage]="'detail'"
  [inspectionKey]="inspection.inspectionKey"></app-navigation>

<div class="page-content">
  <app-inspection-header [inspection]="inspection"></app-inspection-header>

  @if (isStatusEntered()) {
    <app-mkde-alert type="warning">{{
      'ReadonlyScreenDueToEnteredStatus' | translate
    }}</app-mkde-alert>
  }

  @if (notApplicableCategoriesDisplayed) {
    <button
      ngbPopover="{{ 'NZ-Rubriken ausblenden' | translate }}"
      placement="right"
      triggers="mouseenter:mouseleave"
      class="btn btn-link btn-expand btn-category-expand"
      (click)="notApplicableCategoriesDisplayed = !notApplicableCategoriesDisplayed">
      <span class="fas fa-angle-double-left"></span>
    </button>
  }
  @if (!notApplicableCategoriesDisplayed) {
    <button
      ngbPopover="{{ 'NZ-Rubriken einblenden' | translate }}"
      placement="right"
      triggers="mouseenter:mouseleave"
      class="btn btn-link btn-expand btn-category-expand"
      (click)="notApplicableCategoriesDisplayed = !notApplicableCategoriesDisplayed">
      <span class="fas fa-angle-double-right"></span>
    </button>
  }
  <nav ngbNav #nav="ngbNav" class="nav-tabs">
    @for (
      categoryDetail of getCategoriesToDisplay();
      track categoryDetail;
      let categoryDetailIndex = $index
    ) {
      <ng-container [ngbNavItem]="categoryDetailIndex" ngbNavItem>
        <a ngbNavLink>{{ categoryDetail.categoryShortName | i18nText }}</a>
        <ng-template ngbNavContent>
          @if (categoryDetail.presentationType === 'List') {
            <app-detail-list
              (save)="saveInspection()"
              (changeFieldValue)="handlePointFieldValueChange($event)"
              [categoryDetail]="categoryDetail"
              [inspectionCategory]="getInspectionCategory(categoryDetail.categoryNumber)"
              [notApplicableCategoriesDisplayed]="notApplicableCategoriesDisplayed"
              [readonly]="isReadOnly()"></app-detail-list>
          }
          @if (categoryDetail.presentationType === 'Matrix') {
            <app-detail-matrix
              (save)="saveInspection()"
              [categoryDetail]="categoryDetail"
              [inspectionCategory]="getInspectionCategory(categoryDetail.categoryNumber)"
              [notApplicableCategoriesDisplayed]="notApplicableCategoriesDisplayed"
              [readonly]="isReadOnly()"></app-detail-matrix>
          }
          @if (!hideCheckboxControlledCategoriesInPdf) {
            <div>
              <label class="checkbox mb-0">
                <input
                  type="checkbox"
                  [checked]="isSaveForceDisplayOnProtocolChecked(categoryDetail.categoryNumber)"
                  (change)="saveForceDisplayOnProtocol(categoryDetail.categoryNumber)" />
                <span class="checkmark"></span>
                <span class="checkbox-label" translate>Als kontrollierte Rubrik ausgeben</span>
              </label>
            </div>
          }
        </ng-template>
      </ng-container>
    }
    @if (connectionStateService.loggedIn && !isReadOnly()) {
      <div
        class="add-category-link"
        ngbPopover="{{ 'Rubriken hinzufügen' | translate }}"
        placement="bottom"
        triggers="mouseenter:mouseleave">
        <a href="javascript:void(0);" (click)="openInspectionCategoryDialog()"
          ><span class="fas fa-plus-circle"></span
        ></a>
      </div>
    }
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
